import * as React from 'react';
import { useCallback, useState } from 'react';

import { mapIconCell, mapStatusCell } from '../../mappers/brandlift/brandlift';
import { Bem } from '../../service/Bem/Bem';
import { BrandSurveyStatus } from '../../typings/campaigns';
import { IconBrandLift, TranslateBrandLift } from '../../typings/common';
import { GdCampaignPrimaryStatus } from '../../typings/graphql-grid';
import { BrandLiftIFrame } from '../BrandLiftIFrame/BrandLiftIFrame';
import { Shape2, Shape2Icon, Shape2Theme } from '../Shape2/Shape2';

import './CampaignBrandLiftCell.css';

export interface CampaignBrandLiftCellProps {
    brandSurveyStatus: BrandSurveyStatus;
    brandSurveyId: string;
    status: GdCampaignPrimaryStatus;
    clientId: string;
}

const BLOCK = 'campaign-brand-lift';

const useBrandLiftData = (
    brandSurveyStatus: BrandSurveyStatus
): TranslateBrandLift & IconBrandLift => {
    const { surveyStatus } = brandSurveyStatus;

    const mapTextBySurveyStatus = useCallback(mapStatusCell, [
        brandSurveyStatus
    ]);

    const mapIconBySurveyStatus = useCallback(mapIconCell, [surveyStatus]);

    const { title, text } = mapTextBySurveyStatus(brandSurveyStatus);
    const { icon, tone } = mapIconBySurveyStatus(surveyStatus);

    return {
        title,
        text,
        icon,
        tone
    };
};

const useModalBrandLift = () => {
    const [isVisible, setVisible] = useState(false);

    return {
        isVisible,
        onOpen: () => setVisible(true),
        onClose: () => setVisible(false)
    };
};

export const CampaignBrandLiftCell = (props: CampaignBrandLiftCellProps) => {
    const { brandSurveyStatus, brandSurveyId, clientId, status } = props;
    const { title, text, icon, tone } = useBrandLiftData(brandSurveyStatus);
    const { isVisible, onOpen, onClose } = useModalBrandLift();

    const sizeIcon = icon === Shape2Icon.info ? 12 : 16;
    const classIcon =
        icon === Shape2Icon.info ? 'wrapper-icon-shape' : 'wrapper-icon-none';

    return (
        <>
            <div className={Bem.cls(BLOCK)} onClick={onOpen}>
                <div className={Bem.cls(BLOCK, 'wrapper-icon')}>
                    <Shape2
                        theme={Shape2Theme.default}
                        cls={Bem.cls(BLOCK, classIcon)}
                        tone={tone}
                        width={sizeIcon}
                        height={sizeIcon}
                        icon={icon}
                    />
                </div>
                <div className={Bem.cls(BLOCK, 'text')}>
                    <p className={Bem.cls(BLOCK, 'header')}>{title}</p>
                    <p className={Bem.cls(BLOCK, 'content')}>{text}</p>
                </div>
                <div className={Bem.cls(BLOCK, 'wrapper-more')}>
                    <Shape2
                        theme={Shape2Theme.default}
                        cls={Bem.cls(BLOCK, 'more')}
                        width={12}
                        height={12}
                        icon={Shape2Icon.eye}
                    />
                </div>
            </div>
            <BrandLiftIFrame
                clientId={clientId}
                brandSurveyId={brandSurveyId}
                status={status}
                brandSurveyStatus={brandSurveyStatus}
                isVisible={isVisible}
                onClose={onClose}
            />
        </>
    );
};
